import AgentManagement from "./endpoints.agent-management";
import AccessManagement from "./endpoints.access-management";
import AITools from "./endpoints.ai-tools";
import BrokerManagement from "./endpoints.broker-management";
import EmployeeBenefit from "./endpoints.employee-benefit";
import FormManagement from "./endpoints.form-management";
import InsuranceManagement from "./endpoints.insurance-management";
import PartnerManagement from "./endpoints.partner-management";
import ProductManagement from "./endpoints.product-management";
import QappMalaysiaPolicies from "./endpoints.qapp-my.policies";
import CLQuote from "./endpoints.qplus.cl.quote";
import PLEndorsement from "./endpoints.qplus.pl.endorsement";
import PLRenewal from "./endpoints.qplus.pl.renewal";
import Quotation from "./endpoints.quotation";
import RuleEngine from "./endpoints.rule-engine";
import WorkflowEngine from "./endpoints.workflow-engine";
import BankManagement from "./endpoints.bank-management";

export default {
  auth: {
    create: { method: "post", url: "/user/v1/v2/sessions" },
    createSSO: { method: "post", url: "/user/v1/v2/sessions/sso" },
    refresh: { method: "post", url: "/user/v1/v2/sessions/refresh" },
    check: { method: "post", url: "/user/v1/v2/sessions/check" },
    destroy: { method: "delete", url: "/user/v1/v2/sessions/:token" },
    sendOtpForgetPassword: {
      method: "post",
      url: "/user/v1/v2/activations/check-forgot-password",
    },
    resendOtpForgetPassword: {
      method: "post",
      url: "/user/v1/v2/activations/request-forgot-password",
    },
    changePasswordForgetPassword: {
      method: "post",
      url: "/user/v1/v2/activations/confirm-forgot-password",
    },
    sendOtpActivation: {
      method: "post",
      url: "/user/v1/v2/activations/check-verify",
    },
    resendOtpActivation: {
      method: "post",
      url: "/user/v1/v2/activations/request-verify",
    },
    changePasswordActivation: {
      method: "post",
      url: "/user/v1/v2/activations/change-password",
    },
    isCheckingAccount: {
      method: "post",
      url: "/user/v1/v2/activations/check-is-verified",
    },
    saveAuthenticator: {
      method: "put",
      url: "/user/v1/user/v1/v2/users/edit-profile",
    },
  },
  dashboard: {
    generateReport: { method: "get", url: "/cms/report/generate-csv" },
    sendEmail: { method: "post", url: "/cms/cs/send-email" },
  },
  shared: {
    // upload presign file USER SERVICE
    getPresignUrl: {
      method: "post",
      url: "/user/v1/v2/documents/get-upload-url",
    },
  },
  user: {
    list: { method: "get", url: "/user/v1/v2/users" },
    detail: { method: "get", url: "/user/v1/v2/users/:userId" },
    create: { method: "post", url: "/user/v1/v2/users" },
    edit: { method: "put", url: "/user/v1/v2/users/:number" },
    delete: { method: "delete", url: "/user/v1/v2/users/:number" },
    editPassword: { method: "post", url: "/user/v1/v2/users/change-password" },
    editProfile: { method: "put", url: "/user/v1/v2/users/edit-profile" },
    toggleLock: { method: "put", url: "/user/v1/v2/users/:number/toggle-lock" },
    partners: { method: "get", url: "/user/v1/v2/areps/partners" },
    stores: { method: "post", url: "/v2/areps/sections" },
    areps: { method: "get", url: "/v2/areps/:userId" },
  },
  level: {
    list: { method: "get", url: "/user/v1/v2/levels" },
    detail: { method: "get", url: "/user/v1/v2/levels/:levelId" },
    create: { method: "post", url: "/user/v1/v2/levels" },
    edit: { method: "put", url: "/user/v1/v2/levels/:number" },
    delete: { method: "delete", url: "/user/v1/v2/levels/:number" },
  },
  section: {
    list: { method: "get", url: "/user/v1/v2/sections" },
    detail: { method: "get", url: "/user/v1/v2/sections/:sectionId" },
    create: { method: "post", url: "/user/v1/v2/sections" },
    edit: { method: "put", url: "/user/v1/v2/sections/:number" },
    delete: { method: "delete", url: "/user/v1/v2/sections/:number" },
  },
  privilege: {
    list: { method: "get", url: "/user/v1/v2/privileges" },
    detail: { method: "get", url: "/user/v1/v2/privileges/:privilegeId" },
    listPermissions: {
      method: "get",
      url: "/user/v1/v2/privileges/:privilegeId/permission",
    },
    create: { method: "post", url: "/user/v1/v2/privileges" },
    edit: { method: "put", url: "/user/v1/v2/privileges/:privilegeId" },
    delete: { method: "delete", url: "/user/v1/v2/privileges/:privilegeId" },
    addPermissions: {
      method: "post",
      url: "/user/v1/v2/privileges/:privilegeId/permission",
    },
    deletePermissions: {
      method: "delete",
      url: "/user/v1/v2/privileges/:privilegeId/permission",
    },
    deletePermission: {
      method: "delete",
      url: "/user/v1/v2/privileges/:privilegeId/permission/:permissionId",
    },
    editPermissions: {
      method: "put",
      url: "/user/v1/v2/privileges/:privilegeId/permission",
    },
  },
  role: {
    create: { method: "post", url: "/user/v1/v2/roles" },
    list: { method: "get", url: "/user/v1/v2/roles" },
    detail: { method: "get", url: "/user/v1/v2/roles/:roleId" },
    edit: { method: "put", url: "/user/v1/v2/roles/:roleId" },
    delete: { method: "delete", url: "/user/v1/v2/roles/:roleId" },
    addPermissions: {
      method: "post",
      url: "/user/v1/v2/roles/:roleId/permission",
    },
    deletePermissions: {
      method: "delete",
      url: "/user/v1/v2/roles/:roleId/permission",
    },
    deletePermission: {
      method: "delete",
      url: "/user/v1/v2/roles/:roleId/permission/:permissionId",
    },
    editPermissions: {
      method: "put",
      url: "/user/v1/v2/roles/:roleId/permission",
    },
  },
  permission: {
    list: { method: "get", url: "/user/v1/v2/permissions" },
    detail: { method: "get", url: "/user/v1/v2/permissions/:number" },
  },
  organization: {
    list: { method: "get", url: "/user/v1/v2/organizations" },
    detail: { method: "get", url: "/user/v1/v2/organizations/:organizationId" },
    generateCode: {
      method: "get",
      url: "/user/v1/v2/organizations/code/generate",
    },
    generateCodeManually: {
      method: "get",
      url: "/user/v1/v2/organizations/code/check",
    },
    create: { method: "post", url: "/user/v1/v2/organizations" },
    edit: { method: "put", url: "/user/v1/v2/organizations/:organizationId" },
    delete: {
      method: "delete",
      url: "/user/v1/v2/organizations/:organizationId",
    },
  },
  product_categories: {
    list: { method: "get", url: "/user/v1/v2/product-categories" },
  },
  template_role: {
    list: { method: "get", url: "/user/v1/v2/organizations/role-templates" },
  },
  finance: {
    listPolicy: { method: "post", url: "/api/p2p/v2/policies/list" },
    listClaim: { method: "post", url: "/api/p2p/v2/claims/list" },
    listPartners: { method: "get", url: "/api/p2p/v2/partners" },
    detailPolicy: { method: "get", url: "/api/p2p/v2/policies/:number" },
    detailClaim: { method: "get", url: "/api/p2p/v2/claims/:number" },
    claimsHistoriesClaim: {
      method: "get",
      url: "/api/p2p/v2/claims/:number/histories",
    },
    listProduct: { method: "get", url: "/api/p2p/v2/products" },
    listProductCategory: {
      method: "get",
      url: "/api/p2p/v2/products/categories",
    },
    downloadAllPolicy: { method: "post", url: "/api/p2p/v2/policies/reports" },
    downloadAllClaim: { method: "post", url: "/api/p2p/v2/claims/reports" },
    getPresign: { method: "post", url: "/api/p2p/presigned" },
    updateClaim: { method: "post", url: "/api/p2p/v2/claim-histories/:number" },
    processPolicyToClaim: { method: "post", url: "/api/p2p/v2/claims" },
    // later should be change (only for testing)
    listFile: { method: "get", url: "/api/p2p/v2/policies" },
  },
  smartphone: {
    listGadget: {
      method: "post",
      url: "/api/smartphone/v2/catalogs/models/list",
    },
    brand: { method: "get", url: "/api/smartphone/v2/catalogs/brands" },
    categories: {
      method: "get",
      url: "/api/smartphone/v2/catalogs/categories",
    },
    addGadget: { method: "post", url: "/api/smartphone/v2/catalogs/models" },
    updateGadget: {
      method: "put",
      url: "/api/smartphone/v2/catalogs/models/:id",
    },
    deleteGadget: {
      method: "delete",
      url: "/api/smartphone/v2/catalogs/models/:id",
    },
    listServiceCenter: {
      method: "get",
      url: "/api/smartphone/v2/catalogs/service-centers/:brand?availablePickup=1",
    },

    // RPX endpoint
    listProvince: {
      method: "get",
      url: "/api/smartphone/v1/locations/provinces?country=ID",
    },
    listCities: {
      method: "get",
      url: "/api/smartphone/v1/locations/cities?country=ID&province=:province",
    },
    listDistrict: {
      method: "get",
      url: "/api/smartphone/v1/locations/regencies?country=ID&province=:province&district=:district",
    },
    listSubDistrict: {
      method: "get",
      url: "/api/smartphone/v1/locations/zipcodes?country=ID&province=:province&regency=:regency",
    },
    checkingCoverageArea: {
      method: "post",
      url: "/api/smartphone/v2/logistic/zipcode/check",
    },

    // Walkin to pickup
    walkinToPickup: {
      method: "put",
      url: "/api/smartphone/v2/claims/:claimNumber",
    },

    // Activity Log
    activityLog: {
      method: "post",
      url: "/api/smartphone/v2/claims/:claimNumber/add-activity-log",
    },

    // policy APIs
    listPolicy: { method: "post", url: "/api/smartphone/v2/policies/list" },
    detailPolicy: { method: "get", url: "/api/smartphone/v2/policies/:number" },
    sharePolicy: { method: "post", url: "/api/smartphone/v2/policies/resend" },
    addPolicy: { method: "post", url: "/api/smartphone/v2/policies/create" },
    updatePolicy: { method: "put", url: "/api/smartphone/v2/policies/:number" },
    resendPaymentLink: {
      method: "post",
      url: "/api/smartphone/v2/policies/resend-payment-link",
    },
    resendPaymentLinkClaim: {
      method: "post",
      url: "/api/smartphone/v2/claims/resend-payment-link",
    },
    downloadAllPolicy: {
      method: "post",
      url: "/api/smartphone/v2/policies/reports",
    },
    uploadPolicies: {
      method: "post",
      url: "/api/smartphone/v2/policies/upload",
    },
    manualActivation: {
      method: "post",
      url: "api/smartphone/v2/policies/activation",
    },

    // agent
    listAgent: { method: "post", url: "/api/smartphone/v2/agents/download" },
    outlet: { method: "post", url: "/v2/agents/fetch" },

    // products APIs
    listPartners: { method: "get", url: "/api/smartphone/v2/partners" },
    listProduct: { method: "get", url: "/api/smartphone/v2/products" },
    listProductCategory: {
      method: "get",
      url: "/api/smartphone/v2/products/categories",
    },

    // Documents
    getPresignPolicy: {
      method: "post",
      url: "/api/smartphone/v2/presigned/policies",
    },
    getPresign: {
      method: "post",
      url: "/api/smartphone/v1/claims/presigned?type=claims",
    },

    // IMEI APIs
    checkingImei: {
      method: "get",
      url: "/api/smartphone/phones/information/:imei",
    },
    extractImei: { method: "post", url: "api/smartphone/extract-imei" },
    updateImei: { method: "put", url: "api/smartphone/v2/claims/:claimNumber" },

    // Claim APIs
    listClaim: { method: "post", url: "/api/smartphone/v2/claims/list" },
    claimsHistoriesClaim: {
      method: "get",
      url: "/api/smartphone/v2/claims/:number/histories",
    },
    detailClaim: { method: "get", url: "/api/smartphone/v2/claims/:number" },
    searchClaim: { method: "post", url: "/api/smartphone/v2/claims/search" },
    addClaim: { method: "put", url: "/api/smartphone/v2/claims/register" },
    updateClaim: { method: "put", url: "/api/smartphone/v2/claims/:number" },
    downloadAllClaim: {
      method: "post",
      url: "/api/smartphone/v2/claims/reports",
    },
    addCostEstimation: {
      method: "put",
      url: "/api/smartphone/v2/claims/:number",
    },
    fetchQuestionCostEstimation: {
      method: "get",
      url: "/api/smartphone/questions?related=claims",
    },
    uploadFilesCostEstimation: {
      method: "post",
      url: "/v1/claims/presigned?type=claims",
    },
    editPolicyHistory: {
      method: "get",
      url: "/api/smartphone/v2/policies/:number/histories",
    },

    // rework
    rework: { method: "post", url: "/api/smartphone/v2/claims/rework" },
  },
  logistic: {
    listPolicy: { method: "post", url: "/api/logistic/v2/policies/list" },
    listClaim: { method: "post", url: "/api/logistic/v2/claims/list" },
    listPartners: { method: "get", url: "/api/logistic/v2/partners" },
    detailPolicy: { method: "get", url: "/api/logistic/v2/policies/:number" },
    sharePolicy: { method: "post", url: "/api/logistic/v2/policies/resend" },
    resendPaymentLink: {
      method: "post",
      url: "/api/logistic/v2/policies/resend-payment-link",
    },
    detailClaim: { method: "get", url: "/api/logistic/v2/claims/:number" },
    claimsHistoriesClaim: {
      method: "get",
      url: "/api/logistic/v2/claims/:number/histories",
    },
    listProduct: { method: "get", url: "/api/logistic/v2/products" },
    listProductCategory: {
      method: "get",
      url: "/api/logistic/v2/products/categories",
    },
    downloadAllPolicy: {
      method: "post",
      url: "/api/logistic/v2/policies/reports",
    },
    downloadAllClaim: {
      method: "post",
      url: "/api/logistic/v2/claims/reports",
    },
    // old dashboard
    getPresign: {
      method: "post",
      url: "/api/logistic/v2/documents/get-upload-url",
    },
    uploadPolicies: {
      method: "post",
      url: "/api/logistic/policies/bulk-generate",
    },
    processPolicyToClaim: { method: "post", url: "/api/logistic/v2/claims" },
    updateClaim: { method: "put", url: "/api/logistic/v2/claims/:number" },
    listBrand: { method: "get", url: "/api/products/logistic/brand" },
    listType: { method: "get", url: "/api/products/logistic/brand/:id" },
    addPolicy: { method: "post", url: "/api/logistic/v2/policies/create" },
    checkingImei: {
      method: "get",
      url: "/api/logistic/phones/information/:imei",
    },
    searchClaim: { method: "post", url: "/api/logistic/v2/claims/search" },
    addClaim: { method: "put", url: "/api/logistic/v2/claims/register" },
    addCostEstimation: {
      method: "put",
      url: "/api/logistic/v2/claims/:number",
    },
    fetchQuestionCostEstimation: {
      method: "get",
      url: "/api/logistic/questions?related=claims",
    },
    uploadFilesCostEstimation: {
      method: "post",
      url: "/v1/claims/presigned?type=claims",
    },
    extractImei: { method: "post", url: "api/logistic/extract-imei" },

    urlTemplateUpload: {
      method: "post",
      url: "/api/logistic/v2/documents/template",
    },
    getPresignPolicy: {
      method: "post",
      url: "/api/logistic/v2/policies/import-presigned",
    },
    getPresignClaim: {
      method: "post",
      url: "/api/logistic/v2/claims/import-presigned",
    },
  },
  bank: {
    list: { method: "get", url: "/api/payment/internal/banks" },
    detail: { method: "get", url: "/api/payment/internal/banks/:bankId" },
    checkAccountNumber: { method: "post", url: "/v1/kyc/bank-inquiry" },
    getBankId: {
      method: "get",
      url: "/api/payment/internal/banks/name/:bankName",
    },
    setBankAccount: { method: "post", url: "/v2/bank-accounts/self" },
  },
  blast_campaign: {
    // /v2/notifications/documents
    // /v1/notifications/v2/documents
    downloadAllCampaignContact: {
      method: "post",
      url: "/v1/notifications/v2/campaigns/contact-list/exports",
    },
    downloadAllCampaign: {
      method: "post",
      url: "/v1/notifications/v2/campaigns/exports",
    },
    downloadAllReport: {
      method: "post",
      url: "/v1/notifications/v2/reports/exports",
    },
    getPresignDocument: {
      method: "post",
      url: "/v1/notifications/documents/get-upload-url",
    },
    addCampaignContact: {
      method: "post",
      url: "/v1/notifications/v2/campaigns/contact-list/upload",
    },
    getDocument: {
      method: "get",
      url: "/v1/notifications/documents/:filename",
    },
    listTemplate: {
      method: "get",
      url: "/v1/notifications/v2/templates?filter[action]=campaign",
    },
    createBlastCampaign: {
      method: "post",
      url: "/v1/notifications/v2/campaigns",
    },
    executeBlastCampaign: {
      method: "post",
      url: "/v1/notifications/v2/campaigns/execute/:campaignId",
    },
    listCampaign: {
      method: "post",
      url: "/v1/notifications/v2/campaigns/list",
    },
    listCampaignContact: {
      method: "post",
      url: "/v1/notifications/v2/campaigns/contact-list/list",
    },
    listReport: { method: "post", url: "/v1/notifications/v2/reports/list" },
  },
  insurance: {
    productDetail: {
      method: "get",
      url: "/product/v1/internal/products/insurer/detail/:productCode",
    },
    productCategoryList: {
      method: "get",
      url: "/user/v1/v2/product-categories",
    },
    industryList: { method: "get", url: "/api/products/smartphone/brand" },
    addProductCategory: {
      method: "post",
      url: "/user/v1/v2/product-categories",
    },
    editProductCategory: {
      method: "put",
      url: "/user/v1/v2/product-categories/:id",
    },
    deleteProductCategory: {
      method: "delete",
      url: "/user/v1/v2/product-categories/:id",
    },
    getPresignUrl: {
      method: "post",
      url: "/user/v1/v2/documents/get-upload-url",
    },
    getInsuranceById: {
      method: "get",
      url: "/user/v1/v2/organizations/:organizationId",
    },
    getlistProductsByInsuranceId: {
      method: "get",
      url: "/v2/products",
    },
    addInsurerProduct: {
      method: "post",
      url: "/v2/products",
    },
    updateInsurerProduct: {
      method: "put",
      url: "/v2/products/:id",
    },
    getInsuranceProduct: {
      method: "get",
      url: "/v2/products/:id",
    },
    deleteInsurerProduct: {
      method: "delete",
      url: "/v2/products/:id",
    },
    getPresignUrlInsurerProduct: {
      method: "post",
      url: "/api/v2/policies/documents/internal/presigned/upload",
    },
    getPreviewUrlInsurerProduct: {
      method: "post",
      url: "/api/v2/policies/documents/internal/presigned/view",
    },
    updateInsurerProductStatus: {
      method: "put",
      url: "/v2/products/:id/toggle-status",
    },
  },
  partner: {
    addProductCategories: {
      method: "post",
      url: "/user/v1/v2/organizations/:organizationId/product-categories/create",
    },
    editProductCategories: {
      method: "put",
      url: "/user/v1/v2/organizations/:organizationId/product-categories/:productCategoryId",
    },
    deleteProductCategories: {
      method: "delete",
      url: "/user/v1/v2/organizations/:organizationId/product-categories",
    },
    getPartnerById: {
      method: "get",
      url: "/user/v1/v2/organizations/:organizationId",
    },
    getPartnerProductCategoriesById: {
      method: "get",
      url: "/user/v1/v2/organizations/:organizationId/product-categories/:productCategoryId",
    },
    listProductCategoriesByOrganization: {
      method: "get",
      url: "/user/v1/v2/organizations/:organizationId/product-categories/list",
    },
    // ED-2294 Product Categories become product lists.
    products: {
      method: "get",
      url: "/v2/products",
    },
    listProductsV2: {
      method: "get",
      url: "/product-service/internal/onboarding/partner-plans/:product/partners/:partnerCode/plans",
    },
    updateProductV2: {
      method: "post",
      url: "/product-service/internal/onboarding/partner-plans/:product/partners/:partnerCode/plans/:planCode/status",
    },
    deleteProductV2: {
      method: "delete",
      url: "/product-service/internal/onboarding/partner-plans/:product/partners/:partnerCode/plans/:planCode",
    },
    getListProductsByInsuranceIdV2: {
      method: "get",
      url: "/product-service/internal/onboarding/partner-plans/:product/insurances/:insuranceCode/plans",
    },
    getListProductsByInsuranceId: {
      method: "get",
      url: "/v2/products",
    },
    addPartnerProductV2: {
      method: "post",
      url: "/product-service/internal/onboarding/partner-plans/:product/partners/:partnerCode/plans",
    },
    addPartnerProduct: {
      method: "post",
      url: "/v2/products",
    },
    updatePartnerProduct: {
      method: "put",
      url: "/v2/products/:id",
    },
    getPartnerProductV2: {
      method: "get",
      url: "/product-service/internal/onboarding/partner-plans/:insuranceCategory/partners/:partnerCode/plans/:planCode",
    },
    getPartnerProduct: {
      method: "get",
      url: "/v2/products/:id",
    },
    deletePartnerProduct: {
      method: "delete",
      url: "/v2/products/:id",
    },
    updatePartnerProductStatus: {
      method: "put",
      url: "/v2/products/:id/toggle-status",
    },
  },
  commission: {
    self: { method: "get", url: "api/smartphone/v2/commissions/self" },
    list: { method: "get", url: "/user/v1/v2/sections/commissions" },
    detail: { method: "post", url: "api/smartphone/v2/commissions/:uuid/get" },
    values: { method: "post", url: "/api/smartphone/v2/commissions/summary" },
    listCommissionDetail: {
      method: "post",
      url: "/api/smartphone/v2/commissions/:uuid/list",
    },
    listCommissionDetailQuickView: {
      method: "post",
      url: "/api/smartphone/v2/commissions/:uuid/list/statistics",
    },
    approveTransaction: {
      method: "post",
      url: "/api/smartphone/v2/commissions/operation/approve-transactions",
    },
    withdraw: {
      method: "post",
      url: "api/smartphone/v2/commissions/operation/withdrawal",
    },
    summaryStatistic: {
      method: "post",
      url: "api/smartphone/v2/commissions/summary/statistics",
    },
    downloadCommissionDetailReports: {
      method: "post",
      url: "/api/smartphone/v2/commissions/:uuid/list/reports",
    },
  },
  campaign: {
    listActiveCampaigns: {
      method: "get",
      url: "/api/promotion/campaign/internal/list?is_active=true",
    },
    listExpiredCampaigns: {
      method: "get",
      url: "/api/promotion/campaign/internal/list?is_active=false",
    },
    listChannelData: {
      method: "get",
      url: "/api/promotion/campaign/data/:channel",
    },
    listCategories: { method: "get", url: "/api/promotion/categories" },
    detailCampaign: {
      method: "get",
      url: "/api/promotion/campaign?id=:idNumber&is_from_dashboard=true",
    },
    create: { method: "post", url: "/api/promotion/campaign" },
    createV2: { method: "post", url: "/api/promotion/v2/internal/campaign" },
    update: { method: "put", url: "/api/promotion/campaign/:idNumber" },
    updateV2: {
      method: "put",
      url: "/api/promotion/v2/internal/campaign/:idNumber",
    },
    modify: { method: "post", url: "/api/promotion/campaign/action" },
    getPresign: { method: "post", url: "/api/promotion/document/presign" },
    generatePromotionCode: { method: "post", url: "/api/promotion/referral" },
    listCampaignCombination: {
      method: "get",
      url: "/api/promotion/campaign/available-campaign-combine",
    },
  },
  microhealth: {
    listPolicy: { method: "post", url: "/api/health/v2/policies/list" },
    listClaim: { method: "post", url: "/api/health/v2/claims/list" },
    listPartners: { method: "get", url: "/api/health/v2/partners" },
    detailPolicy: { method: "get", url: "/api/health/v2/policies/:number" },
    detailClaim: { method: "get", url: "/api/health/v2/claims/:number" },
    listProduct: { method: "get", url: "/api/health/v2/products" },
    listProductCategory: {
      method: "get",
      url: "/api/health/v2/products/categories",
    },
    downloadAllPolicy: {
      method: "post",
      url: "/api/health/v2/policies/reports",
    },
    downloadAllClaim: { method: "post", url: "/api/health/v2/claims/reports" },
    getPresign: { method: "post", url: "/api/health/v1.0/claims/presigned" },
    getPresignPolicy: {
      method: "post",
      url: "/api/health/v2/policies/import-presigned",
    },
    updateClaim: {
      method: "post",
      url: "/api/health/v2/claim-histories/:number",
    },
    claimsHistoriesClaim: {
      method: "get",
      url: "/api/health/v2/claims/:number/histories",
    },
    claimsHistoriesPolicy: {
      method: "get",
      url: "/api/health/v2/policy/:number/histories",
    },
    urlTemplateUpload: {
      method: "post",
      url: "/api/health/v2/documents/template",
    },
    uploadPolicies: { method: "post", url: "/api/health/v2/policies/generate" },
    sharePolicy: { method: "post", url: "/api/health/hcp/generate" },
  },
  goods: {
    listPolicy: { method: "post", url: "/api/electronic/v2/policies/list" },
    listClaim: { method: "post", url: "/api/electronic/v2/claims/list" },
    listPartners: { method: "get", url: "/api/electronic/v2/partners" },
    detailPolicy: { method: "get", url: "/api/electronic/v2/policies/:number" },
    detailClaim: { method: "get", url: "/api/electronic/v2/claims/:number" },
    listProduct: { method: "get", url: "/api/electronic/v2/products" },
    listProductCategory: {
      method: "get",
      url: "/api/electronic/v2/products/categories",
    },
    downloadAllPolicy: {
      method: "post",
      url: "/api/electronic/v2/policies/reports",
    },
    downloadAllClaim: {
      method: "post",
      url: "/api/electronic/v2/claims/reports",
    },
    getPresignPolicy: {
      method: "post",
      url: "/api/electronic/v2/presigned/policies",
    },
    uploadPolicies: {
      method: "post",
      url: "/api/electronic/v2/policies/upload",
    },
    updateClaim: { method: "put", url: "/api/electronic/v2/claims/:number" },
    claimsHistoriesClaim: {
      method: "get",
      url: "/api/electronic/v2/claims/:number/histories",
    },
    claimsHistoriesPolicy: {
      method: "get",
      url: "/api/electronic/v2/policy/:number/histories",
    },
  },
  flight: {
    listPolicy: { method: "post", url: "/api/flight/v2/policies/list" },
    listClaim: { method: "post", url: "/api/flight/v2/claims/list" },
    listPartners: { method: "get", url: "/api/flight/v2/partners" },
    detailPolicy: { method: "get", url: "/api/flight/v2/policies/:number" },
    sharePolicy: { method: "post", url: "/api/flight/v2/policies/resend" },
    detailClaim: { method: "get", url: "/api/flight/v2/claims/:number" },
    listProduct: { method: "get", url: "/api/flight/v2/products" },
    listProductCategory: {
      method: "get",
      url: "/api/flight/v2/products/categories",
    },
    downloadAllPolicy: {
      method: "post",
      url: "/api/flight/v2/policies/reports",
    },
    downloadAllClaim: { method: "post", url: "/api/flight/v2/claims/reports" },
    getPresignPolicy: {
      method: "post",
      url: "/api/flight/v2/presigned/policies",
    },
    getPresign: { method: "post", url: "/api/flight/v2/documents" },
    uploadPolicies: { method: "post", url: "/api/flight/v2/policies/upload" },
    updateClaim: { method: "put", url: "/api/flight/v2/claims/:number" },
    claimsHistoriesClaim: {
      method: "get",
      url: "/api/flight/v2/claims/:number/histories",
    },
    claimsHistoriesPolicy: {
      method: "get",
      url: "/api/flight/v2/policy/:number/histories",
    },
    editPolicy: { method: "patch", url: "/api/flight/v2/policies/:number" },
    editPolicyHistory: {
      method: "get",
      url: "/api/flight/v2/policies/:number/histories",
    },
  },
  train: {
    listPolicy: { method: "post", url: "/api/train/v2/policies/list" },
    listClaim: { method: "post", url: "/api/train/v2/claims/list" },
    listPartners: { method: "get", url: "/api/train/v2/partners" },
    detailPolicy: { method: "get", url: "/api/train/v2/policies/:number" },
    detailClaim: { method: "get", url: "/api/train/v2/claims/:number" },
    listProduct: { method: "get", url: "/api/train/v2/products" },
    listProductCategory: {
      method: "get",
      url: "/api/train/v2/products/categories",
    },
    downloadAllPolicy: {
      method: "post",
      url: "/api/train/v2/policies/reports",
    },
    downloadAllClaim: { method: "post", url: "/api/train/v2/claims/reports" },
    getPresignPolicy: {
      method: "post",
      url: "/api/train/v2/presigned/policies",
    },
    getPresign: { method: "post", url: "/api/train/v2/documents" },
    uploadPolicies: { method: "post", url: "/api/train/v2/policies/upload" },
    updateClaim: { method: "put", url: "/api/train/v2/claims/:number" },
    claimsHistoriesClaim: {
      method: "get",
      url: "/api/train/v2/claims/:number/histories",
    },
    claimsHistoriesPolicy: {
      method: "get",
      url: "/api/train/v2/policy/:number/histories",
    },
  },
  customer_management: {
    listCustomer: { method: "post", url: "/v2/customers" },
    detailCustomer: { method: "get", url: "/v2/customers/:number" },
    listStatus: { method: "post", url: "/v2/customers/statuses" },
    updateBankStatus: {
      method: "post",
      url: "/v2/customers/:number/kyc/update-bank-status",
    },
    updateIDStatus: {
      method: "post",
      url: "/v2/customers/:number/kyc/update-id-status",
    },
  },
  bus: {
    listPolicy: { method: "post", url: "/api/bus/v2/policies/list" },
    listClaim: { method: "post", url: "/api/bus/v2/claims/list" },
    listPartners: { method: "get", url: "/api/bus/v2/partners" },
    detailPolicy: { method: "get", url: "/api/bus/v2/policies/:number" },
    sharePolicy: {
      method: "post",
      url: "/api/bus/v2/policies/:number/resend-certificate",
    },
    detailClaim: { method: "get", url: "/api/bus/v2/claims/:number" },
    listProduct: { method: "get", url: "/api/bus/v2/products" },
    listProductCategory: {
      method: "get",
      url: "/api/bus/v2/products/categories",
    },
    downloadAllPolicy: { method: "post", url: "/api/bus/v2/policies/reports" },
    downloadAllClaim: { method: "post", url: "/api/bus/v2/claims/reports" },
    getPresignPolicy: { method: "post", url: "/api/bus/v2/presigned/policies" },
    getPresign: { method: "post", url: "/api/bus/v2/documents" },
    uploadPolicies: { method: "post", url: "/api/bus/v2/policies/upload" },
    updateClaim: { method: "put", url: "/api/bus/v2/claims/:number" },
    claimsHistoriesClaim: {
      method: "get",
      url: "/api/bus/v2/claims/:number/histories",
    },
    claimsHistoriesPolicy: {
      method: "get",
      url: "/api/bus/v2/policy/:number/histories",
    },
  },
  hotel: {
    listPolicy: { method: "post", url: "/api/accomm/v2/policies/list" },
    listClaim: { method: "post", url: "/api/accomm/v2/claims/list" },
    listPartners: { method: "get", url: "/api/accomm/v2/partners" },
    detailPolicy: { method: "get", url: "/api/accomm/v2/policies/:number" },
    sharePolicy: {
      method: "post",
      url: "/api/accomm/v2/policies/:number/resend-certificate",
    },
    detailClaim: { method: "get", url: "/api/accomm/v2/claims/:number" },
    listProduct: { method: "get", url: "/api/accomm/v2/products" },
    listProductCategory: {
      method: "get",
      url: "/api/accomm/v2/products/categories",
    },
    downloadAllPolicy: {
      method: "post",
      url: "/api/accomm/v2/policies/reports",
    },
    downloadAllClaim: { method: "post", url: "/api/accomm/v2/claims/reports" },
    getPresignPolicy: {
      method: "post",
      url: "/api/accomm/v2/presigned/policies",
    },
    getPresign: { method: "post", url: "/api/accomm/v2/documents" },
    uploadPolicies: { method: "post", url: "/api/accomm/v2/policies/upload" },
    updateClaim: { method: "put", url: "/api/accomm/v2/claims/:number" },
    claimsHistoriesClaim: {
      method: "get",
      url: "/api/accomm/v2/claims/:number/histories",
    },
    claimsHistoriesPolicy: {
      method: "get",
      url: "/api/accomm/v2/policy/:number/histories",
    },
  },
  common: {
    provinces: { method: "get", url: "/user/v1/api/list-of-province" },
  },
  personal_lines: {
    listPersonalLine: {
      method: "get",
      url: `${process.env.API_BASE_URL_Q_PLUS}/api/go-quotation/dashboard/v1/quotes`,
    },
    listQuickView: {
      method: "get",
      url: `${process.env.API_BASE_URL_Q_PLUS}/api/go-quotation/dashboard/v1/insurances`,
    },
    detailPersonalLine: {
      method: "get",
      url: "/api/flight/v2/policies/:number",
    },
    listProduct: { method: "get", url: "/api/flight/v2/products" },
    listProductCategory: {
      method: "get",
      url: "/api/flight/v2/products/categories",
    },
    downloadAllPersonalLine: {
      method: "get",
      url: `${process.env.API_BASE_URL_Q_PLUS}/api/go-quotation/dashboard/v1/quotes/action/download`,
    },
    getPresign: { method: "post", url: "/api/flight/v2/documents" },
    getPresignPolicy: {
      method: "post",
      url: "/api/smartphone/v2/presigned/policies",
    },
    listInsuranceBranch: {
      method: "get",
      url: `${process.env.API_BASE_URL_Q_PLUS}/quotation/v2/dashboard/v1/insurers/:insurerCode/branches`,
    },
  },
  pl_endorsement: PLEndorsement,
  pl_renewal: PLRenewal,
  partnership: {
    claimList: {
      method: "post",
      url: "/claim/v1/internal/list",
    },
    claimDetail: {
      method: "get",
      url: "/claim/v1/internal/:number/detail",
    },
    historyClaimList: {
      method: "get",
      url: "/claim/v1/internal/:number/histories",
    },
    updateClaim: {
      method: "put",
      url: "/claim/v1/internal/update",
    },
    updateBulkClaim: {
      method: "post",
      url: "/claim/v1/internal/bulk-update",
    },
    searchClaim: {
      method: "post",
      url: "/claim/v1/internal/search",
    },
    policyList: {
      method: "post",
      url: "/api/v2/policies/internal/list",
    },
    policyDetail: {
      method: "get",
      url: "/api/v2/policies/internal/:number/detail",
    },
    listPartners: {
      method: "get",
      url: "/user/v1/v2/organizations/self/relations",
    },
    partnershipUploadPolicypresignUrl: {
      method: "post",
      url: "/api/v2/policies/quotes/internal/presigned/upload",
    },
    partnershipUploadClaimpresignUrl: {
      method: "post",
      url: "/claim/v1/internal/presigned/upload",
    },
    downloadAllClaim: {
      method: "post",
      url: "/claim/v1/internal/download",
    },
    downloadAllClaimV2: {
      method: "post",
      url: "/claim/v1/internal/download/pulse",
    },
    downloadAllPolicy: {
      method: "post",
      url: "/api/v2/policies/internal/download",
    },
    downloadAllPolicyV2: {
      method: "post",
      url: "/api/v2/policies/internal/v2/download/pulse",
    },
    productCodeList: {
      method: "get",
      url: "/api/v2/products/:product/internal/products/partner/list",
    },
    productList: {
      method: "get",
      url: "/user/v1/v2/organizations/:code/product-categories/list",
    },
    claimPresignUrl: {
      method: "post",
      url: "/claim/v1/document/presign",
    },
    productCategoryList: {
      method: "get",
      url: "/api/v2/products/:product/internal/products/product-categories",
    },
    stoplossList: {
      method: "get",
      url: "/api/v2/products/:product/internal/products/stoploss",
    },
    claimFormList: {
      method: "get",
      url: "/claim/v1/internal/form-templates",
    },
    claimFormDetail: {
      method: "get",
      url: "/claim/v1/internal/form-templates/:uuid",
    },
    claimLogList: {
      method: "get",
      url: "/claim/v1/internal/policies/:number/claims",
    },
    sharePolicy: {
      method: "post",
      url: "/api/v2/policies/internal/resend-policy",
    },
    createInvoice: {
      method: "post",
      url: "/api/v2/policies/internal/invoices/create",
    },
    summaryInvoice: {
      method: "post",
      url: "/api/v2/policies/internal/invoices/summaries",
    },
    productGroupList: {
      method: "get",
      url: "/api/v2/products/finance/internal/products-groups",
    },
    invoiceList: {
      method: "post",
      url: "/api/v2/policies/internal/invoices/list",
    },
    invoiceDetail: {
      method: "get",
      url: "/api/v2/policies/internal/invoices/:number",
    },
    cancelInvoice: {
      method: "patch",
      url: "/api/v2/policies/internal/invoices/:number",
    },
    historyInvoice: {
      method: "get",
      url: "/api/v2/policies/internal/invoices/:number/histories",
    },
    summaryInvoicePayment: {
      method: "get",
      url: "/api/v2/policies/internal/invoices/summaries/payment/:number",
    },
    markAsPaidInvoice: {
      method: "patch",
      url: "/api/v2/policies/internal/invoices/:number",
    },
    resendPaymentLink: {
      method: "post",
      url: "/api/v2/policies/internal/invoices/resend-payment-link",
    },
    claimDisbursementList: {
      method: "post",
      url: "/claim/v1/internal/disbursement/list",
    },
    claimDisbursementDetail: {
      method: "get",
      url: "/claim/v1/internal/disbursement/list/:paymentId",
    },
    historyClaimDisbursement: {
      method: "get",
      url: "/claim/v1/internal/disbursement/finance/:number/histories",
    },
    updateStatusClaimDisbursement: {
      method: "post",
      url: "/claim/v1/disbursement",
    },
    cancelClaimDisbursement: {
      method: "patch",
      url: "/claim/v1/internal/disbursement/:number",
    },
    createClaimDisbursement: {
      method: "post",
      url: "/claim/v1/internal/disbursement/create",
    },
    summaryClaimDisbursement: {
      method: "post",
      url: "/claim/v1/internal/disbursement/summaries",
    },
    summaryDisbursementPayment: {
      method: "get",
      url: "/claim/v1/internal/disbursement/summaries/payment/:number",
    },
    markAsPaidDisbursement: {
      method: "patch",
      url: "/claim/v1/internal/disbursement/:number",
    },
    claimPoolList: {
      method: "post",
      url: "/api/v2/products/finance/internal/stoploss",
    },
    claimPoolDetail: {
      method: "get",
      url: "/api/v2/products/finance/internal/stoploss/:code",
    },
    claimPoolHistory: {
      method: "post",
      url: "/api/v2/products/finance/internal/stoploss/histories",
    },
    retryPayment: {
      method: "post",
      url: "/claim/v1/internal/payment/retry",
    },
    listNotificationTemplate: {
      method: "post",
      url: "/api/v2/products/finance/internal/notification/template/list",
    },
    createNotificationTemplate: {
      method: "post",
      url: "/api/v2/products/finance/internal/notification/template",
    },
    postProductDetail: {
      method: "post",
      url: "/api/v2/products/finance/internal/policy/validate",
    },
    ocrInvoicePhoto: {
      method: "post",
      url: "/api/v2/policies/internal/ocr/invoice",
    },
    createQuotation: {
      method: "post",
      url: "/api/v2/policies/internal/quotes",
    },
    productVersionList: {
      method: "post",
      url: "/api/v2/products/finance/internal/products/histories/list",
    },
    gadgetListCatalog: {
      method: "post",
      url: "/api/v2/products/finance/internal/products/schema/gadget-list-catalog",
    },
    metadataCatalogsGadget: {
      method: "get",
      url: "/api/v2/products/finance/internal/metadata/catalogs/gadget",
    },
    getMetadataGadgetById: {
      method: "get",
      url: "/api/v2/products/finance/internal/metadata/:id",
    },
    createMetadataGadget: {
      method: "post",
      url: "/api/v2/products/finance/internal/metadata",
    },
    editMetadataGadget: {
      method: "put",
      url: "/api/v2/products/finance/internal/metadata/:id",
    },
  },
  claim_form_template: {
    templateList: {
      method: "get",
      url: "/claim/v1/internal/form-templates",
    },
    createTemplate: {
      method: "post",
      url: "/claim/v1/internal/form-templates",
    },
    detailTemplate: {
      method: "get",
      url: "/claim/v1/internal/form-templates/:uuid",
    },
  },
  qapp_my: QappMalaysiaPolicies,
  commercial_lines: CLQuote,

  finops_additional_fee_request: {
    list: {
      method: "get",
      url: `${process.env.API_BASE_URL_Q_PLUS}/api/go-quotation/v1/dashboard/paid-to-insurer-quotes`,
    },
  },

  finops_commission_request: {
    list: {
      method: "get",
      url: `${process.env.API_BASE_URL_Q_PLUS}/api/go-quotation/v1/dashboard/basic-commission-gaps`,
    },
  },

  finops_commission_from_insurance_transaction: {
    list: {
      method: "get",
      url: `${process.env.API_BASE_URL_Q_PLUS}/api/go-quotation/v1/dashboard/basic-commission-gaps/invoices`,
    },
  },

  finops_commission_from_insurance_transaction_detail: {
    quoteList: {
      method: "get",
      url: `${process.env.API_BASE_URL_Q_PLUS}/api/go-quotation/v1/dashboard/basic-commission-gaps/invoices/:uuid/quotations
`,
    },
  },

  finops_invoice_list: {
    list: {
      method: "get",
      url: `${process.env.API_BASE_URL_Q_PLUS}/api/go-quotation/v1/dashboard/paid-to-insurer-invoices`,
    },
  },

  finops_invoice_detail_quote_list: {
    list: {
      method: "get",
      url: `${process.env.API_BASE_URL_Q_PLUS}/api/go-quotation/v1/dashboard/paid-to-insurer-invoices/:uuid/quotations`,
    },
  },

  finops_payment_to_insurer_request: {
    list: {
      method: "get",
      url: `${process.env.API_BASE_URL_Q_PLUS}/api/go-quotation/v1/insurers/:insurerCode/quotes`,
    },
    download: {
      method: "get",
      url: `${process.env.API_BASE_URL_Q_PLUS}/api/go-quotation/v1/insurers/:insurerCode/quotes?format=FILE`,
    },
    insurance_branch_list: {
      method: "get",
      url: `${process.env.API_BASE_URL_Q_PLUS}/api/go-quotation/v1/insurers/:insurerId/branches?isActiveOnly=false`,
    },
    request_summary: {
      method: "get",
      url: `${process.env.API_BASE_URL_Q_PLUS}/api/go-quotation/v1/insurers/:insurerCode/quotes?format=SUMMARY`,
    },
    request_payment: {
      method: "post",
      url: `${process.env.API_BASE_URL_Q_PLUS}/api/go-quotation/v1/insurers/:insurerCode/invoice`,
    },
  },
  finops_payment_to_insurer_transaction: {
    list: {
      method: "get",
      url: `${process.env.API_BASE_URL_Q_PLUS}/api/go-quotation/v1/insurers/:insurerCode/payments`,
    },
    insurance_branch_list: {
      method: "get",
      url: `${process.env.API_BASE_URL_Q_PLUS}/api/go-quotation/v1/insurers/:insurerId/branches?isActiveOnly=false`,
    },
    download: {
      method: "get",
      url: `${process.env.API_BASE_URL_Q_PLUS}/api/go-quotation/v1/insurers/:insurerCode/payments?format=FILE`,
    },
  },

  finops_payment_to_insurer_transaction_detail: {
    quoteList: {
      method: "get",
      url: `${process.env.API_BASE_URL_Q_PLUS}/api/go-quotation/v1/invoice/:uuid/insurer?type=QUOTES`,
    },
  },

  employeeBenefit: EmployeeBenefit,
  productManagement: ProductManagement,

  ruleEngine: RuleEngine,
  formManagement: FormManagement,
  insuranceManagement: InsuranceManagement,
  PartnerManagement,

  workflowEngine: WorkflowEngine,
  Quotation,
  AITools,
  AgentManagement,
  BrokerManagement,
  AccessManagement,
  BankManagement,
};
